module.exports = __webpack_public_path__ + "static/FL3-36428383601c48cc85161531a803a8cf.jpg";